import { render } from "./BillingProfileEdit.vue?vue&type=template&id=7c0c3af0"
import script from "./BillingProfileEdit.vue?vue&type=script&lang=js"
export * from "./BillingProfileEdit.vue?vue&type=script&lang=js"

import "./BillingProfileEdit.vue?vue&type=style&index=0&id=7c0c3af0&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__